<template>
    <div>

        <navbar></navbar>

        <div class="bg-header-round-small">
            <div class="container">
                <h1>Für Händler</h1>
            </div>
        </div>

        <section class="container">
            <h2>COUCHGOURMET
                – DER MARKTPLATZ DER ZUKUNFT </h2>

            <p>Profitieren Sie als Mitglied der couchgourmet Fachgeschäft-
            Community von einem attraktiven Verkaufsumfeld
            und einer für die Bedarfe des Fachhandels
            maßgeschneiderten Rundum-Sorglos-Lösung:
            inklusive Web-Cam, Warenwirtschaftssystem und 24/7
            Online-Shop.
            </p>

            <h2>IHRE WICHTIGSTEN VORTEILE </h2>
            <p>Live-Shop
            für echte Verkaufsgespräche
            Landesweiter Vertrieb Ihres Angebots:
            inklusive Versand und Logistik
            Umfassendes Warenwirtschaftssystem
            leicht bedienbar
            Attraktives Verkaufsumfeld
            samt professionellem Marketing
            Zeit- und Kostenersparnis
            gegenüber herkömmlichen Web-Shops
            24/7 Online-Shop
            weil Sie auch mal schlafen müssen
            </p>

            <h2>WARUM DAS LADENGESCHÄFT OFT NICHT AUSREICHT …</h2>
            <p>Gesetzlich reglementierte Verkaufszeiten
            (statt freiem 24/7 Verkauf)
            Limitierte, lokale Käuferschaft
            (statt regionalem und überregionalem Verkauf)
            Ungünstige Verkaufszeiten für kaufkräftige Vollerwerbstätige
            Hohe Personalkosten
            (zu umsatzschwachen Tageszeiten)
            Veränderte Kundenerwartungen und neues Kaufverhalten der Digital Natives
            </p>

            <h2>… UND EIN BLOßER ONLINE-SHOP NICHT WEITERHILFT.</h2>
            <p>Keine Kundenbindung durch anonymen Bestellvorgang
            (statt persönlichem Verkaufsgespräch)
            Komplizierte Bedienung und Fehleranfälligkeit des Warenwirtschaftssystems
            Keine flexible Preis- und Rabattgestaltung
            Geringeres Vertrauen der Kundschaft in Online-Angebote
            Hohe Kosten für bestehende Online-Konzepte
            </p>

            <h2>SO EINFACH GEHT’S</h2>

            <ul>
                <li>
                    1) Der Kunde registriert sich in Ihrem einzigartigen Live-Shop-System
                </li>
                <li>
                    2) Persönliche Beratung an der Video-Theke. Der Kunde sieht, was er bekommt
                </li>
                <li>
                    3) Lieferung direkt zu ihm nach Hause, in die Arbeit, bzw. an die Wunschadresse
                    Nun kann der Kunde entscheiden: Vakuumierte Ware direkt genießen, zubereiten oder einfrieren
                </li>
            </ul>

            <p>Der Schlemmergarten in München nutzt das Couch Gourmet-Prinzip seit 4 Jahren, um seine Produkte landesweit als Live-Frischetheke online anzubieten und zu liefern. Mit großem Erfolg. Der Couch Gourmet-Pionier Andreas Sparber konnte seinen Umsatz Dank des Live-Shop-Systems steigern. Erfahren Sie, wie seine Kunden Couch-Gourmet erleben und nutzen.</p>


        </section>

        <cgfooter></cgfooter>

    </div>
</template>

<script>
  import Navbar from '@/components/Navbar.vue'
  import CgFooter from '@/components/CgFooter.vue'

  export default {
    name: 'servicePartner',
    components: {
      'navbar': Navbar,
      'cgfooter': CgFooter
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/service/Partner.vue